import { Link } from "react-router-dom";
import { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { registerFetcher } from "../../api/requests";
import {
  Redirect,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import { useToaster } from "../../context/toaster";

function Signup() {
  const [signUpData, setSignUpData] = useState({});
  const [errors, setErrors] = useState({
    status: false,
    value: [],
  });
  const phoneRegex = /^09\d{9}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*]{8,}$/;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { addMessage, messages } = useToaster();
  const logo2 = process.env.PUBLIC_URL + "/img/vaghfnama-logo.png";

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleChange = (name, value) => {
    setSignUpData({ ...signUpData, [name]: value });
  };

  const handleSignUp = async () => {
    setLoading(true);
    setErrors((prevErrors) => ({
      ...prevErrors,
      status: true,
      value: [],
    }));

    // Validate input fields
    if (
      (phoneRegex.test(signUpData.username) ||
        emailRegex.test(signUpData.username)) &&
      passRegex.test(signUpData.password) &&
      signUpData.password === signUpData.confirm_password
    ) {
      try {
        const signUpResponse = await registerFetcher.post(signUpData);

        if (
          signUpResponse.message ===
          "Registration successful! Please verify your account."
        ) {
          showToast("success", "ثبت‌ نام موفقیت‌آمیز بود.");

          setLoading(false);

          setErrors((prevErrors) => ({
            ...prevErrors,
            value: [],
          }));

          history.push("/auth/confirmation", { username: signUpData.username });
        }
      } catch (error) {
        setLoading(false);
        setErrors((prevErrors) => ({
          ...prevErrors,
          status: true,
          value: Object.values(error.response?.data || ["خطایی رخ داده است"]),
        }));
      } finally {
        setLoading(false);
      }
    } else {
      // Handle validation errors
      setLoading(false);
      !(
        phoneRegex.test(signUpData.username) ||
        emailRegex.test(signUpData.username)
      ) &&
        setErrors((prevErrors) => ({
          ...prevErrors,
          value: [...prevErrors.value, "نام کاربری صحیح نمی باشد."],
        }));

      !passRegex.test(signUpData.password) &&
        setErrors((prevErrors) => ({
          ...prevErrors,
          value: [...prevErrors.value, "رمز ورود صحیح نمی باشد."],
        }));

      signUpData.password !== signUpData.confirm_password &&
        setErrors((prevErrors) => ({
          ...prevErrors,
          value: [...prevErrors.value, "رمز ورود و تکرار آن برابر نیستند."],
        }));
    }
  };

  return (
    <>
      <Col md={5} className="p-5 bg-white full-height">
        <div className="login-main-left">
          <div className="text-center mb-5 login-main-left-header pt-4">
            <a href="/">
              <img src={logo2} width="40%" className="img-fluid" alt="LOGO" />
            </a>
            <h5 className="mt-3 mb-3">خوش آمدید</h5>
            <p>لطفا ثبت نام کنید.</p>
          </div>
          <Form
            className="text-right"
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default form submission
              handleSignUp(); // Handle sign-up logic
            }}
          >
            <Form.Group>
              <Form.Label>شماره موبایل</Form.Label>
              <Form.Control
                onChange={(e) => handleChange("username", e.target.value)}
                type="text"
                placeholder="شماره موبایل خود را وارد کنید..."
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>رمز ورود</Form.Label>
              <Form.Control
                onChange={(e) => handleChange("password", e.target.value)}
                type="password"
                placeholder="رمز ورود باید حداقل 8 کرکتر از حروف و اعداد باشد"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>تکرار رمز ورود</Form.Label>
              <Form.Control
                type="password"
                onChange={(e) =>
                  handleChange("confirm_password", e.target.value)
                }
                placeholder=""
              />
            </Form.Group>

            <div className="mt-4">
              <Row>
                <Col>
                  <Button
                    type="submit" // Explicitly mark it as a submit button
                    variant="outline-primary"
                    size="lg"
                    block
                    style={{ cursor: loading ? "wait" : "pointer" }}
                  >
                    {loading ? "لطفا منتظر بمانید..." : "ثبت نام"}
                  </Button>
                  {errors.status &&
                    errors.value.map((item, index) => (
                      <p key={index} className="text-danger mt-1">
                        {item}
                      </p>
                    ))}
                </Col>
              </Row>
            </div>
          </Form>

          <div className="text-center mt-5">
            <p className="light-gray">
              حساب کاربری دارید؟ <Link to="/auth/login">ورود</Link>
            </p>
          </div>
        </div>
      </Col>
    </>
  );
}

export default Signup;
